import type { AppThunk } from 'state';
import type { GetFlightRoutesRequestParameters } from 'common/packageCache';
import { PackageCacheFlightRoutesService } from 'common/packageCache';
import FetchingStatus from 'constants/statuses/FetchingStatus';
import handleRequestError from 'managers/handleRequestError';
import { setFetching, setFlightRoutesResponse } from '../slice';

function fetchFlightRoutes(requestParameters: GetFlightRoutesRequestParameters): AppThunk {
  return async function fetchFlightRoutesThunk(dispatch, getState) {
    try {
      const { fetching } = getState().flightRoutes.routes;

      if (fetching === FetchingStatus.InProgress) {
        return;
      }

      dispatch(setFetching(FetchingStatus.InProgress));

      const data = await PackageCacheFlightRoutesService.getFlightRoutes(requestParameters);

      if (!data) {
        dispatch(setFetching(FetchingStatus.Failed));
        return;
      }

      dispatch(setFlightRoutesResponse(data));
      dispatch(setFetching(FetchingStatus.Succeeded));
    } catch (error) {
      dispatch(handleRequestError(error, 'Error occured on fetch flight routes!', setFetching));
    }
  };
}

export default fetchFlightRoutes;
